<template>
  <v-card outlined rounded class="rounded-lg">
    <v-card-text></v-card-text>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      show-select
      item-key="id"
      :items-per-page="25"
      dense
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Targhe</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            depressed
            class="mr-2"
            :disabled="selected.length < 1"
            outlined
            @click="deleteSelected"
            ><v-icon>mdi-trash-can-outline</v-icon> Elimina selezionati</v-btn
          >
          <create-surveys-form />
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card rounded="lg">
              <v-card-title class="text-h5">Conferma l'azione</v-card-title>
              <v-card-text>
                Questa operazione è irreversibile ed eliminerà definitavamente i dati. Vuoi comunque procedere?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialogDelete = false">Annulla</v-btn>
                <v-btn color="error" depressed @click="confirmDelete">Elimina</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.vehicle_targa="{ item }">
        <span class="font-weight-bold" style="font-family: monospace; letter-spacing: 0.5px">{{
          item.vehicle_targa
        }}</span>
      </template>

      <template v-slot:item.link="{ item }">
        <a :href="item.link" target="_blank">link</a>
      </template>

      <template v-slot:item.vehicle_stopped="{ item }">
        <div v-if="item.vehicle_stopped === null"></div>
        <div v-else>{{ item.vehicle_stopped ? 'FERMO' : 'ATTIVO' }}</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn :to="{ name: 'admin-survey-detail', params: { id: item.id } }" icon link>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click="deleteSurvey(item)" icon>
            <v-icon dark color="error">mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// Components
import CreateSurveysForm from '@/components/forms/CreateSurveysForm.vue'

// Store
import { mapState, mapActions } from 'vuex'

// Third-party libs
import { format } from 'date-fns'

// Component
export default {
  components: {
    CreateSurveysForm,
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      selected: [],
      deleteItems: null,
      headers: [
        // { text: 'ID', value: 'id' },
        { text: 'Targa', value: 'vehicle_targa' },
        { text: 'Prov. imm.', value: 'vehicle_province' },
        { text: 'P. Utile', value: 'vehicle_load_capacity' },
        { text: 'Anno', value: 'year' },
        { text: 'Trimestre', value: 'quarter' },
        { text: 'Settimana', value: 'week' },
        { text: 'Campione', value: 'sample' },
        { text: 'Link', value: 'link' },
        { text: 'Stato', value: 'vehicle_stopped' },
        { text: 'Iniziato', value: 'started_at' },
        { text: 'Completato', value: 'submitted_at' },
        { text: '', value: 'actions', sortable: false },
      ],
    }
  },
  mounted() {
    this.$store.dispatch('surveys/init')
  },
  computed: {
    ...mapState('surveys', ['surveys', 'loading']),
    items() {
      const baseUrl = window.location.origin
      return this.surveys.map((s) => ({
        ...s,
        stopped: s.vehicle_stopped ? 'FERMO' : 'ATTIVO',
        started_at: s.started_at, // ? format(s.started_at?.toDate(), 'yyyy-MM-dd HH:mm') : null,
        submitted_at: s.submitted_at ? format(s.submitted_at.toDate(), 'yyyy-MM-dd HH:mm') : null,
        // TODO: Usare v-router
        link: `${baseUrl}/compila-questionario?token=${s.id}`,
      }))
    },
  },
  methods: {
    ...mapActions('surveys', ['delete', 'bulkDelete']),
    async confirmDelete() {
      if (this.deleteItems.length === 1) {
        await this.delete(this.deleteItems[0].id)
      } else {
        await this.bulkDelete(this.deleteItems)
      }
      this.dialogDelete = false
    },
    deleteSelected() {
      this.deleteItems = this.selected
      this.dialogDelete = true
    },
    deleteSurvey(item) {
      this.deleteItems = [item]
      this.dialogDelete = true
    },
  },
}
</script>

<style lang="scss" scoped></style>
